/**
 * Deoxylocks Hydrogel Free Gift + Review
 */

(function () {
  'use strict';

  var page = document.getElementById('hydrogel-gift');
  if (!page) return;

  var CLOUDINARY_CLOUD  = page.dataset.cloudinaryCloud  || '';
  var CLOUDINARY_PRESET = page.dataset.cloudinaryPreset || '';

  // Intentionally the same Web3Forms access key the derma-roller review-gift
  // track on the Ambassador Page uses, so both shipping requests and reviews
  // land in the same inbox.
  var W3F_KEY = '28b6de37-be4f-4f4e-929a-f5f4ff04d208';

  var STORAGE_KEY = 'deoxylocks_hydrogel_gift_v1';

  var selectedReviewPhotos = [];

  // ── Shared helpers ───────────────────────────────────────
  function val(id) { return (document.getElementById(id) || {}).value || ''; }
  function checked(id) { return !!((document.getElementById(id) || {}).checked); }

  function setErr(id, msg) {
    var el = document.getElementById(id);
    if (el) el.textContent = msg || '';
  }

  function getState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function saveState(patch) {
    try {
      var state = getState();
      Object.keys(patch).forEach(function (k) { state[k] = patch[k]; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* ignore (private browsing, etc.) */ }
  }

  function submitToWeb3Forms(fields) {
    fields.access_key = W3F_KEY;
    return fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fields),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || !data.success) throw new Error(data.message || 'Web3Forms error');
      });
    });
  }

  function firstNameFrom(fullName) {
    return (fullName || '').trim().split(' ')[0] || 'friend';
  }

  // ── Shipping form ─────────────────────────────────────────
  function initShippingForm() {
    var submitBtn = document.getElementById('hg-shipping-submit');
    if (!submitBtn) return;

    var state = getState();
    if (state.shippingSubmitted) {
      showShippingSuccess();
      return;
    }

    submitBtn.addEventListener('click', function () {
      if (!validateShippingForm()) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
      submitShippingForm()
        .then(function (d) {
          saveState({ shippingSubmitted: true, fullName: d.fullName, email: d.email });
          showShippingSuccess();
        })
        .catch(function (err) {
          console.error('[Deoxylocks Hydrogel] Shipping submit failed:', err);
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<span class="hg-btn-dot"></span> Try Again';
        });
    });
  }

  function validateShippingForm() {
    var valid = true;
    var checks = [
      ['hg-err-fullName',     !val('hg-fullName').trim(),               'Required'],
      ['hg-err-email',        !/^\S+@\S+\.\S+$/.test(val('hg-email')), 'Enter a valid email'],
      ['hg-err-inviteCode',   !val('hg-inviteCode').trim(),             'Required'],
      ['hg-err-address1',     !val('hg-address1').trim(),               'Required'],
      ['hg-err-city',         !val('hg-city').trim(),                   'Required'],
      ['hg-err-zip',          !val('hg-zip').trim(),                    'Required'],
      ['hg-err-ackAgreement', !checked('hg-ackAgreement'),             'Please confirm to continue'],
    ];
    checks.forEach(function (c) {
      if (c[1]) { setErr(c[0], c[2]); valid = false; } else setErr(c[0], '');
    });
    return valid;
  }

  function getShippingData() {
    return {
      fullName:   val('hg-fullName'),
      email:      val('hg-email'),
      inviteCode: val('hg-inviteCode').trim().toUpperCase(),
      address1: val('hg-address1'),
      address2: val('hg-address2'),
      city:     val('hg-city'),
      state:    val('hg-state'),
      zip:      val('hg-zip'),
      country:  val('hg-country'),
      heardAbout: val('hg-heardAbout'),
    };
  }

  function submitShippingForm() {
    var d = getShippingData();
    return submitToWeb3Forms({
      subject: 'New Hydrogel Shipping Request – ' + d.fullName,
      from_name: d.fullName,
      'Form Type': 'Hydrogel Shipping Request',
      Name: d.fullName, Email: d.email,
      'Invitation Code': d.inviteCode,
      'Address': d.address1, 'Address 2': d.address2,
      'City': d.city, 'State': d.state, 'ZIP': d.zip, 'Country': d.country,
      'Heard About Us': d.heardAbout,
      'Product': '2-Deoxy-D-Ribose Multi-Active Hair Density Hydrogel',
      'Agreement Accepted': 'Yes',
    }).then(function () { return d; });
  }

  function showShippingSuccess() {
    var card = document.getElementById('hg-shipping-card');
    if (!card) return;
    var bodyText = page.dataset.shippingSuccessBody || 'Your gift will ship soon.';
    card.innerHTML =
      '<div class="hg-card-body"><div class="hg-success">'
      + '<div class="hg-success-mark"><svg viewBox="0 0 48 48" width="40" height="40" fill="none" aria-hidden="true">'
      + '<circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="1.2"/>'
      + '<path d="M14 24 L21 31 L34 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></div>'
      + '<h3>Thank you! Your request has been received.</h3>'
      + '<p>' + bodyText + '</p>'
      + '</div></div>';
  }

  // ── Review form ───────────────────────────────────────────
  function initReviewForm() {
    var submitBtn = document.getElementById('hg-review-submit');
    if (!submitBtn) return;

    var state = getState();
    if (state.reviewSubmitted) {
      showReviewSuccess(state.reviewFullName || state.fullName || '');
      return;
    }

    // Prefill from the shipping step if it happened earlier in this browser.
    if (state.fullName) {
      var nameField = document.getElementById('hg-rev-fullName');
      if (nameField && !nameField.value) nameField.value = state.fullName;
    }
    if (state.email) {
      var emailField = document.getElementById('hg-rev-email');
      if (emailField && !emailField.value) emailField.value = state.email;
    }

    var textArea = document.getElementById('hg-rev-text');
    if (textArea) {
      textArea.addEventListener('input', function () {
        var counter = document.getElementById('hg-rev-text-count');
        if (counter) counter.textContent = textArea.value.length + ' / 1000';
      });
    }

    var starGroup = document.getElementById('hg-rev-stars');
    if (starGroup) {
      starGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('.hg-star');
        if (!btn) return;
        var v = parseInt(btn.dataset.value, 10);
        starGroup.querySelectorAll('.hg-star').forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.value, 10) <= v);
        });
        starGroup.dataset.selected = v;
      });
    }

    submitBtn.addEventListener('click', function () {
      if (!validateReviewForm()) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
      submitReviewForm()
        .then(function (d) {
          saveState({ reviewSubmitted: true, reviewFullName: d.fullName });
          showReviewSuccess(d.fullName);
        })
        .catch(function (err) {
          console.error('[Deoxylocks Hydrogel] Review submit failed:', err);
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<span class="hg-btn-dot"></span> Try Again';
        });
    });
  }

  function validateReviewForm() {
    var valid = true;
    var checks = [
      ['hg-err-rev-fullName', !val('hg-rev-fullName').trim(),               'Required'],
      ['hg-err-rev-email',    !/^\S+@\S+\.\S+$/.test(val('hg-rev-email')), 'Enter a valid email'],
      ['hg-err-rev-text',     !val('hg-rev-text').trim(),                   'Please share your feedback'],
      ['hg-err-rev-stars',    !document.getElementById('hg-rev-stars').dataset.selected, 'Please select a rating'],
    ];
    checks.forEach(function (c) {
      if (c[1]) { setErr(c[0], c[2]); valid = false; } else setErr(c[0], '');
    });
    return valid;
  }

  function getReviewData() {
    return {
      fullName:   val('hg-rev-fullName'),
      email:      val('hg-rev-email'),
      starRating: document.getElementById('hg-rev-stars').dataset.selected || '',
      reviewText: val('hg-rev-text'),
    };
  }

  function uploadPhotosToCloudinary(files) {
    if (!files.length || !CLOUDINARY_CLOUD || !CLOUDINARY_PRESET) return Promise.resolve([]);
    var uploads = files.map(function (file) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', CLOUDINARY_PRESET);
      return fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload', {
        method: 'POST', body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.secure_url || ''; })
        .catch(function () { return ''; });
    });
    return Promise.all(uploads);
  }

  function initPhotoUpload() {
    var dropzone  = document.getElementById('hg-rev-photo-dropzone');
    var fileInput = document.getElementById('hg-rev-photo-input');
    var previews  = document.getElementById('hg-rev-photo-previews');
    if (!dropzone || !fileInput || !previews) return;

    function addFiles(files) {
      Array.prototype.forEach.call(files, function (file) {
        if (selectedReviewPhotos.length >= 3) return;
        if (!file.type.match(/^image\//)) return;
        selectedReviewPhotos.push(file);
        var reader = new FileReader();
        reader.onload = function (e) {
          var idx = selectedReviewPhotos.indexOf(file);
          var thumb = document.createElement('div');
          thumb.className = 'hg-photo-thumb';
          thumb.dataset.idx = idx;
          thumb.innerHTML =
            '<img src="' + e.target.result + '" alt="Preview">'
            + '<button type="button" class="hg-photo-thumb-remove" aria-label="Remove photo">&times;</button>';
          previews.appendChild(thumb);
          updateDropzone();
        };
        reader.readAsDataURL(file);
      });
    }

    function updateDropzone() {
      dropzone.style.display = selectedReviewPhotos.length >= 3 ? 'none' : '';
    }

    previews.addEventListener('click', function (e) {
      var btn = e.target.closest('.hg-photo-thumb-remove');
      if (!btn) return;
      var thumb = btn.closest('.hg-photo-thumb');
      var idx = parseInt(thumb.dataset.idx, 10);
      selectedReviewPhotos.splice(idx, 1);
      previews.querySelectorAll('.hg-photo-thumb').forEach(function (t, i) { t.dataset.idx = i; });
      thumb.remove();
      updateDropzone();
    });

    dropzone.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
    dropzone.addEventListener('dragover', function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
    dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('is-dragover'); });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault(); dropzone.classList.remove('is-dragover');
      addFiles(e.dataTransfer.files);
    });
  }

  function submitReviewForm() {
    var d = getReviewData();
    return uploadPhotosToCloudinary(selectedReviewPhotos).then(function (photoUrls) {
      var fields = {
        subject: 'New Hydrogel Review Submission – ' + d.fullName,
        from_name: d.fullName,
        'Form Type': 'Hydrogel Review Submission',
        Name: d.fullName, Email: d.email,
        'Star Rating': d.starRating, 'Review': d.reviewText,
      };
      if (photoUrls[0]) fields['Photo 1'] = photoUrls[0];
      if (photoUrls[1]) fields['Photo 2'] = photoUrls[1];
      if (photoUrls[2]) fields['Photo 3'] = photoUrls[2];
      return submitToWeb3Forms(fields).then(function () { return d; });
    });
  }

  function showReviewSuccess(fullName) {
    var card = document.getElementById('hg-review-card');
    if (!card) return;
    var firstName = firstNameFrom(fullName);
    var bodyText  = page.dataset.reviewSuccessBody || 'Thank you for your feedback.';
    card.innerHTML =
      '<div class="hg-card-body"><div class="hg-success">'
      + '<div class="hg-success-mark"><svg viewBox="0 0 48 48" width="40" height="40" fill="none" aria-hidden="true">'
      + '<circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="1.2"/>'
      + '<path d="M14 24 L21 31 L34 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></div>'
      + '<h3>Thank you, ' + firstName + '.</h3>'
      + '<p>' + bodyText + '</p>'
      + '</div></div>';
  }

  // ── Invitation code prefill (?invite=XXXX) ────────────────
  // Convenience only — the code is not validated against anything here.
  function prefillInviteCode() {
    try {
      var invite = new URLSearchParams(window.location.search).get('invite');
      var field  = document.getElementById('hg-inviteCode');
      if (invite && field && !field.value) field.value = invite;
    } catch (e) { /* ignore */ }
  }

  // ── Init ─────────────────────────────────────────────────
  prefillInviteCode();
  initPhotoUpload();
  initShippingForm();
  initReviewForm();

})();
